import { CommonModule, TitleCasePipe } from '@angular/common';
import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import _ from 'lodash';
import { MenuItem } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DatepickerComponent } from '../../../../@core/components/ui/datepicker/datepicker.component';
import { DialogComponent } from 'src/app/@core/components/ui/dialog/dialog.component';
import { DrawerModule } from 'primeng/drawer';
import { Menu, MenuModule } from 'primeng/menu';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { PopoverModule } from 'primeng/popover';
import { TooltipModule } from 'primeng/tooltip';
import { Subscription } from 'rxjs';
import { ButtonComponent } from '../../../../@core/components/ui/button/button.component';
import { DeleteConfirmationComponent } from '../../../../@core/components/ui/delete-confirmation/delete-confirmation.component';
import { PopoverComponent } from '../../../../@core/components/ui/popover/popover.component';
import { SelectComponent, SelectOption, SelectConfig } from '../../../../@core/components/ui/select';
import { SelectButtonComponent } from '../../../../@core/components/ui/select-button/select-button.component';
import { IUser, IWorkspace, SHARE_ACCESS } from '../../../../@core/models/model';
import { AuthenticationService } from '../../../../@core/services/authentication.service';
import { SOCKET_EVENTS, SocketService } from '../../../../@core/services/socket.service';
import { ToastService } from '../../../../@core/services/toast.service';
import { DocumentCardComponent } from '../../../../@shared/components/document-card/document-card.component';
import { GridListViewComponent } from '../../../../@shared/components/grid-list-view/grid-list-view.component';
import { LottieAnimationComponent } from '../../../../@shared/components/lottie-animation/lottie-animation.component';
import { SearchBarComponent } from '../../../../@shared/components/search-bar/search-bar.component';
import { TableColumn, TableConfig } from '../../../../@shared/models/table.models';
import { escapeRegExp } from '../../../../common/utils';
import { CONTRACT_DOCUMENTS, CONTRACT_TYPE, CONTRACT_GENERATION_STATUS, IContract } from '../../../models/contract-management.model';
import { IDocumentType } from '../../../models/settings.model';
import { IStatus } from '../../../../@core/models/model';
import { DOCUMENT_CREATION_SOURCE, ContractService, IContractResponse } from '../../../services/contracts.service';
import { DocumentTypeFilter, DocumentTypeService } from '../../../services/document-type.service';
import { INotification, NOTIFICATION_EVENTS } from '../../../services/notification.service';
import { OrganizationSetupFormService } from '../../../services/organization-setup-from.service';
import { UserService } from '../../../services/user.service';
import { STANDARD_DOCUMENT_STATUS } from '../../settings/documents/document-status/document-status.enum';
import { DOCUMENTS_TABLE_COLUMNS, DOCUMENTS_TABLE_CONFIG } from '../../documents/documents-table.config';
import { SegmentedOption } from '../../../../@core/components/ui/segmented/segmented.component';
import { AssetUrlPipe } from '../../../../@shared/pipes/asset-url.pipe';
import { AiAssistantComponent } from "src/app/@shared/components/ai-assistant/ai-assistant.component";
import { GENERATE_WITH_AI_TABLE_COLUMNS, GENERATE_WITH_AI_TABLE_CONFIG } from './generate-with-ai-table-config';
import { GenerateDocumentComponent } from "src/app/@shared/components/generate-document/generate-document.component";
import { ProjectService } from '../../../services/project.service';

@Component({
    selector: 'app-generate-with-ai',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        DialogComponent,
        DrawerModule,
        MenuModule,
        PaginatorModule,
        PopoverModule,
        TooltipModule,
        AvatarModule,
        AvatarGroupModule,
        CheckboxModule,
        ConfirmDialogModule,
        TitleCasePipe,
        ButtonComponent,
        SearchBarComponent,
        SelectButtonComponent,
        SelectComponent,
        DatepickerComponent,
        GridListViewComponent,
        DocumentCardComponent,
        PopoverComponent,
        DeleteConfirmationComponent,
        LottieAnimationComponent,
        AssetUrlPipe,
        GenerateDocumentComponent
    ],
    templateUrl: './generate-with-ai.component.html',
    styleUrl: './generate-with-ai.component.scss'
})
export class GenerateWithAiComponent implements OnInit, OnDestroy {
    @ViewChild('menu') menu!: Menu;
    @ViewChild('sortOverlay') sortOverlay!: PopoverComponent;
    @ViewChildren(DocumentCardComponent) documentCards!: QueryList<DocumentCardComponent>;

    @ViewChild('documentNameTemplateRef') documentNameTemplateRef!: TemplateRef<any>;
    @ViewChild('documentTypeTemplateRef') documentTypeTemplateRef!: TemplateRef<any>;
    @ViewChild('createdByTemplateRef') createdByTemplateRef!: TemplateRef<any>;
    @ViewChild('projectTemplateRef') projectTemplateRef!: TemplateRef<any>;
    @ViewChild('statusTemplateRef') statusTemplateRef!: TemplateRef<any>;
    @ViewChild('dueDateTemplateRef') dueDateTemplateRef!: TemplateRef<any>;
    @ViewChild('dateCreatedTemplateRef') dateCreatedTemplateRef!: TemplateRef<any>;
    @ViewChild('actionsTemplateRef') actionsTemplateRef!: TemplateRef<any>;

    currentUser!: IUser;
    currentWorkspace!: IWorkspace | null | undefined;
    contractMenuItems: MenuItem[] | undefined;
    isLoading = false;
    contractsLoaded = false
    searchValue = '';
    contracts: IContractResponse[] = [];
    viewMode: 'grid' | 'list' = 'grid';
    tableColumns: TableColumn[] = GENERATE_WITH_AI_TABLE_COLUMNS;
    tableConfig: TableConfig = { ...GENERATE_WITH_AI_TABLE_CONFIG };
    contractOptions: SelectOption[] = [];
    statusOptions: SelectOption[] = [];
    peopleOptions: SelectOption[] = [];
    headerText = CONTRACT_DOCUMENTS.ALL;
    selectedCode: CONTRACT_TYPE = CONTRACT_TYPE.ALL;
    rename: { open: boolean; newName: IContract['name']; contractId: IContract['_id'] } = { open: false, newName: '', contractId: '' };
    dueDate: { open: boolean; selectedDate: Date | null; contractId: IContract['_id'] } = { open: false, selectedDate: null, contractId: '' };
    deleteDialogVisible = false;
    contractToDelete: { id: string; name: string } | null = null;
    currentDate: Date = new Date();

    defaultPaginatorValues = { first: 0, rows: 20 };
    first = this.defaultPaginatorValues.first;
    rows = this.defaultPaginatorValues.rows;
    totalRecords = 0;
    contractsLength = 0;
    openMenus: PopoverComponent[] = [];
    notificationSubscription!: Subscription;
    currentlyOpenPopoverId: string | null = null;
    currentMenuDocument: { id: string; name: string } | null = null;

    users: IUser[] = [];
    selectedPeople: string | null = null;
    sortField: 'name' | 'createdAt' | 'dueDate' | 'lastEdited' = 'createdAt';
    sortOrder: 'asc' | 'desc' = 'desc';
    filterDueDateRange: Date[] | null = null;
    filterCreatedDateRange: Date[] | null = null;
    filterPanelVisible = false;
    selectedStatus: STANDARD_DOCUMENT_STATUS | null = null;
    docTypeOptions: SelectOption[] = [];
    selectedDocTypeId: string | null = null;
    projects: { _id: string; name: string }[] = [];
    selectedProjectId: string | null = null;
    projectOptions: SelectOption[] = [];

    viewModeOptions: SegmentedOption[] = [
        { label: 'List', value: 'list', icon: 'pi pi-bars' },
        { label: 'Grid', value: 'grid', icon: 'pi pi-th-large' }
    ];

    contractSelectConfig: SelectConfig = { placeholder: 'Select option', searchable: false, clearable: false, style: { width: '100%' } };
    peopleSelectConfig: SelectConfig = { placeholder: 'Select person', searchable: true, clearable: false, style: { width: '100%' } };
    docTypeSelectConfig: SelectConfig = { placeholder: 'Select document type', searchable: true, clearable: false, style: { width: '100%' } };
    statusSelectConfig: SelectConfig = { placeholder: 'Select status', searchable: true, clearable: false, style: { width: '100%' } };
    projectSelectConfig: SelectConfig = { placeholder: 'Select Project', searchable: true, clearable: true, style: { width: '100%' } };

    CONTRACT_GENERATION_STATUS = CONTRACT_GENERATION_STATUS;
    generationStatus: CONTRACT_GENERATION_STATUS = CONTRACT_GENERATION_STATUS.COMPLETED;
    templateGenerationAnimationData: any = null;
    generationInProgress = false;

    generateContractDialogVisible = false;
    generateContractGeneratingDialogVisible = false;

    currentGeneratingDocumentsCount = 0;

    generateContractLoading = false

    constructor(
        private socketService: SocketService,
        private contractService: ContractService,
        private authService: AuthenticationService,
        private toastService: ToastService,
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private documentTypeService: DocumentTypeService,
        private organizationService: OrganizationSetupFormService,
        private projectService: ProjectService
    ) {
        this.currentUser = this.authService.getUser() as IUser;
        this.organizationService.currentWorkspace.subscribe(res => (this.currentWorkspace = res));
        this.contractOptions = [
            { label: 'All', value: CONTRACT_TYPE.ALL },
            { label: 'Created by me', value: CONTRACT_TYPE.DRAFTED },
            { label: 'Shared with me', value: CONTRACT_TYPE.SHARED }
        ];
        this.selectedDocTypeId = this.route.snapshot.queryParamMap.get('docTypeId') ?? null;
        this.loadGenerationAnimation();
        this.isLoading = true;
        this.tableConfig = { ...this.tableConfig, loading: true };
        // this.checkJobInProgress();
    }

    ngOnInit() {
        // this.checkJobInProgress();
        this.getAllStatuses();
        this.getAllUsersOfOrganization();
        this.getProjects();
        this.getAllDocumentTypes();
        this.notificationSubscription = this.socketService
            .on<{ notification: INotification }>(SOCKET_EVENTS.NOTIFICATION)
            .subscribe(res => {
                const notification = res[0].notification;
                if (notification.subModule === NOTIFICATION_EVENTS.DOCUMENT.GENERATED) {
                    const contract = (notification.event.data as { contractData: IContract }).contractData;
                    if (
                        (this.defaultPaginatorValues.first === 0 && this.searchValue === '' || escapeRegExp(contract.name).toLowerCase().includes(this.searchValue.trim())) &&
                        this.currentWorkspace?._id === contract.workspace
                    ) {
                        this.contracts.unshift(contract as IContractResponse);
                        if (this.contractsLength < this.defaultPaginatorValues.rows) this.contractsLength++;
                        else this.contracts.pop();
                    }
                    this.generationStatus = CONTRACT_GENERATION_STATUS.COMPLETED;
                    this.generateContractGeneratingDialogVisible = false;
                    this.templateGenerationAnimationData = null;
                    this.fetchContracts(this.first, this.rows);
                }
            });
    }

    // checkJobInProgress() {
    //     this.generationInProgress = true;
    //     this.contractService.checkGenWithAiInProgress(
    //         {
    //             docTypeId: this.selectedDocTypeId ?? '',
    //             source: this.docTypeOptions.find(docType => docType.value === this.selectedDocTypeId)?.data.name == 'CONTRACT' ? DOCUMENT_CREATION_SOURCE.CONTRACT_GENERATION : DOCUMENT_CREATION_SOURCE.STANDARD
    //         }
    //     ).subscribe({
    //         next: res => {
    //             if (res && res.data) {
    //                 this.generationStatus = CONTRACT_GENERATION_STATUS.IN_PROGRESS;
    //                 this.generateContractGeneratingDialogVisible = true;
    //                 this.loadTemplateGenerationAnimation();
    //             }
    //             this.generationInProgress = false;
    //         },
    //         error: () => {
    //             this.generationInProgress = false;
    //         }
    //     });
    // }

    loadGenerationAnimation() {
        fetch('/animations/template_generation.json')
            .then(response => (response.ok ? response.json() : Promise.reject(new Error(`HTTP error! status: ${response.status}`))))
            .then(data => (this.templateGenerationAnimationData = data))
            .catch(() => (this.templateGenerationAnimationData = null));
    }

    get templatesMap(): { [key: string]: TemplateRef<any> } {
        return {
            documentNameTemplate: this.documentNameTemplateRef,
            documentTypeTemplate: this.documentTypeTemplateRef,
            projectTemplate: this.projectTemplateRef,
            createdByTemplate: this.createdByTemplateRef,
            statusTemplate: this.statusTemplateRef,
            dueDateTemplate: this.dueDateTemplateRef,
            dateCreatedTemplate: this.dateCreatedTemplateRef,
            actionsTemplate: this.actionsTemplateRef
        };
    }

    onViewModeChange(mode: 'grid' | 'list') {
        this.viewMode = mode;
    }

    onPageChange(event: PaginatorState) {
        this.first = event.first ?? this.defaultPaginatorValues.first;
        this.rows = event.rows ?? this.defaultPaginatorValues.rows;
        this.fetchContracts(this.first, this.rows);
    }

    fetchContracts(skip = this.defaultPaginatorValues.first, limit = this.defaultPaginatorValues.rows) {
        this.isLoading = true;
        this.contractsLoaded = false;
        this.tableConfig = { ...this.tableConfig, loading: true };
        let source = this.docTypeOptions.find(docType => docType.value === this.selectedDocTypeId)?.data.name == 'CONTRACT' ? DOCUMENT_CREATION_SOURCE.CONTRACT_GENERATION : DOCUMENT_CREATION_SOURCE.STANDARD;
        const filters: any = {
            type: this.selectedCode,
            skip,
            limit,
            name: this.searchValue.trim(),
            sortField: this.sortField,
            sortOrder: this.sortOrder,
            documentType: this.selectedDocTypeId,
            source: source,
            generationStatus: [CONTRACT_GENERATION_STATUS.IN_PROGRESS, CONTRACT_GENERATION_STATUS.COMPLETED],
        };
        if (this.selectedPeople) filters.createdBy = this.selectedPeople;
        if (this.selectedProjectId) filters.projectId = this.selectedProjectId;
        if (this.selectedDocTypeId) filters.linkedDocType = this.selectedDocTypeId;
        if (this.selectedStatus) filters.documentStatus = this.selectedStatus;
        if (this.filterDueDateRange?.length === 2) {
            filters.dueDateStart = this.filterDueDateRange[0].toISOString();
            filters.dueDateEnd = this.filterDueDateRange[1].toISOString();
        }
        if (this.filterCreatedDateRange?.length === 2) {
            filters.createdDateStart = this.filterCreatedDateRange[0].toISOString();
            filters.createdDateEnd = this.filterCreatedDateRange[1].toISOString();
        }
        this.contractService.getContracts(filters).subscribe((res) => {
            if (res?.success) {
                this.isLoading = false;
                this.tableConfig = { ...this.tableConfig, loading: false };
                const documents = (res.data?.contracts || []).map((p: IContractResponse) =>
                    p.dueDate ? { ...p, dueDateExceeding: this.contractService.checkIfDueDateExceeding(p.dueDate) } : p
                );
                this.contracts = documents as IContractResponse[];
                this.totalRecords = res.data?.total ?? 0;
                this.contractsLength = this.totalRecords > this.defaultPaginatorValues.rows ? this.totalRecords : this.contracts.length;
                this.currentGeneratingDocumentsCount = res.data?.contracts.filter((contract: IContractResponse) => contract.generationStatus === CONTRACT_GENERATION_STATUS.IN_PROGRESS).length ?? 0;
            } else {
                this.isLoading = false;
                this.tableConfig = { ...this.tableConfig, loading: false };
                this.totalRecords = 0;
                this.contracts = [];
            }
            this.contractsLoaded = true;
        });
    }

    searchContract = _.debounce(() => {
        this.first = this.defaultPaginatorValues.first;
        this.rows = this.defaultPaginatorValues.rows;
        this.fetchContracts(this.first, this.rows);
    }, 500);

    onSearch() {
        this.isLoading = true;
        this.searchContract();
    }

    setSortField(field: 'name' | 'createdAt' | 'dueDate' | 'lastEdited') {
        this.sortField = field;
        this.sortOverlay.hide();
        this.first = 0;
        this.fetchContracts(this.first, this.rows);
    }

    setSortOrder(order: 'asc' | 'desc') {
        this.sortOrder = order;
        this.sortOverlay.hide();
        this.first = 0;
        this.fetchContracts(this.first, this.rows);
    }

    toggleFilterPanel() {
        this.filterPanelVisible = !this.filterPanelVisible;
    }

    getProjects() {
        this.projectService.getProjects(0, 1000, { active: true }).subscribe(res => {
            this.projects = res.data.projects ?? [];
            this.projectOptions = this.projects.map(project => ({ label: project.name, value: project._id, data: project }));
        });
    }

    handleProjectChange(event: any) {
        this.selectedProjectId = event.value;
    }

    clearAllFilters() {
        this.filterDueDateRange = null;
        this.filterCreatedDateRange = null;
        this.selectedPeople = null;
        this.selectedProjectId = null;
        this.selectedDocTypeId = null;
        this.selectedStatus = null;
        this.selectedCode = CONTRACT_TYPE.ALL;
        this.headerText = CONTRACT_DOCUMENTS.ALL;
        this.first = 0;
        this.fetchContracts(this.first, this.rows);
        this.filterPanelVisible = false;
    }

    applyFilters() {
        if (this.selectedCode === CONTRACT_TYPE.DRAFTED) this.headerText = CONTRACT_DOCUMENTS.DRAFTED;
        else if (this.selectedCode === CONTRACT_TYPE.SHARED) this.headerText = CONTRACT_DOCUMENTS.SHARED;
        else this.headerText = CONTRACT_DOCUMENTS.ALL;
        this.first = 0;
        this.fetchContracts(this.first, this.rows);
        this.filterPanelVisible = false;
    }

    getAllStatuses() {
        this.statusOptions = Object.values(STANDARD_DOCUMENT_STATUS).map(status => ({ label: status, value: status }));
    }

    getAllUsersOfOrganization() {
        this.userService.getUsers().subscribe(res => {
            this.users = res.data?.users ?? [];
            this.peopleOptions = this.users.map(user => ({
                label: user.firstName ? (user.lastName ? `${user.firstName} ${user.lastName}` : user.firstName) : (user.lastName ?? user.email),
                value: user._id,
                data: user
            }));
        });
    }

    getAllDocumentTypes() {
        this.documentTypeService.getDocTypes([DocumentTypeFilter.GENERAL, DocumentTypeFilter.FORM_RELATED]).subscribe(res => {
            const data = (res as { data?: IDocumentType[] })?.data ?? (Array.isArray(res) ? res as IDocumentType[] : []);
            if (data.length) {
                this.docTypeOptions = data.map((docType: IDocumentType) => ({ label: docType.name, value: docType._id, data: docType }));
                const docTypeIdFromRoute = this.route.snapshot.queryParamMap.get('docTypeId');
                if (docTypeIdFromRoute && this.docTypeOptions.some(opt => opt.value === docTypeIdFromRoute)) {
                    this.selectedDocTypeId = docTypeIdFromRoute;
                } else {
                    this.selectedDocTypeId = this.docTypeOptions.find(docType => docType.label === 'CONTRACT')?.value ?? null;
                }
            }
            this.fetchContracts(this.defaultPaginatorValues.first, this.defaultPaginatorValues.rows);
        });
    }

    getMenuItems(document: IContractResponse): MenuItem[] {
        const items: MenuItem[] = [];
        const currentUserRoles = Array.isArray((document)?.currentUserRole) ? (document).currentUserRole : ((document)?.currentUserRole ? [(document).currentUserRole] : []);
        const canManage = currentUserRoles.includes(SHARE_ACCESS.ADMIN) || currentUserRoles.includes(SHARE_ACCESS.OWNER) || currentUserRoles.includes(SHARE_ACCESS.EDIT) || currentUserRoles.includes(SHARE_ACCESS.ORG_ADMIN);
        if (canManage) {
            items.push(
                { label: 'Rename', icon: 'pi pi-pencil' },
                { label: 'Due Date', icon: 'pi pi-calendar' },
                { label: 'Delete', icon: 'pi pi-trash', styleClass: 'text-danger' });
        }
        return [{ label: 'Options', items }];
    }

    handleChange(event: any) {
        this.selectedCode = event.value;
    }

    handlePeopleChange(event: any) {
        this.selectedPeople = event.value;
    }

    handleDocTypeChange(event: any) {
        this.selectedDocTypeId = event.value;
    }

    handleStatusChange(event: any) {
        this.selectedStatus = event.value;
    }

    openContract(contractId: string, generationStatus: CONTRACT_GENERATION_STATUS, source?: DOCUMENT_CREATION_SOURCE) {
        if (generationStatus === CONTRACT_GENERATION_STATUS.IN_PROGRESS) {
            this.generateContractGeneratingDialogVisible = true;
            return;
        }
        const navSource = source ?? DOCUMENT_CREATION_SOURCE.STANDARD;
        this.router.navigate(['edit-document'], { queryParams: { documentId: contractId, source: navSource } });
    }

    deleteContract(_event: unknown, contractId: string, contractName: string) {
        this.contractToDelete = { id: contractId, name: contractName };
        this.deleteDialogVisible = true;
    }

    confirmDeleteContract() {
        if (!this.contractToDelete) return;
        this.contractService.deleteContract(this.contractToDelete.id).subscribe(res => {
            if (res.success) {
                this.toastService.success('Document deleted successfully');
                this.fetchContracts(this.first, this.rows);
            } else this.toastService.error('Error deleting contract');
            this.deleteDialogVisible = false;
            this.contractToDelete = null;
        });
    }

    renameContract(event: Event) {
        if (!this.rename.newName.trim()) this.rename.newName = 'Untitled';
        this.contractService.updateContract(this.rename.contractId, { name: this.rename.newName }).subscribe(res => {
            if (res.success) {
                this.toastService.success('Document renamed successfully');
                this.fetchContracts(this.first, this.rows);
            } else this.toastService.error('Error renaming contract');
            this.resetRename();
        });
    }

    resetRename() {
        this.rename = { open: false, newName: '', contractId: '' };
    }

    saveDueDate(event: Event) {
        event.stopPropagation();
        const dueDateValue = this.dueDate.selectedDate ?? undefined;
        this.contractService.updateContract(this.dueDate.contractId, { dueDate: dueDateValue }).subscribe(res => {
            if (res.success) {
                this.toastService.success('Due Date updated successfully');
                const idx = this.contracts.findIndex(c => c._id === this.dueDate.contractId);
                if (idx !== -1) this.contracts[idx] = { ...this.contracts[idx], dueDate: dueDateValue };
                this.fetchContracts(this.first, this.rows)
            } else this.toastService.error('Error updating Due Date');
            this.resetDueDate();
            this.menu.hide();
        });
    }

    resetDueDate() {
        this.dueDate = { open: false, selectedDate: null, contractId: '' };
    }

    handleMenuClick(event: Event, contractId: string, contractName: string, item: MenuItem) {
        event.stopPropagation();
        if (item.label === 'Delete') this.deleteContract(event, contractId, contractName);
        else if (item.label === 'Rename') this.rename = { open: true, newName: '', contractId };
        else if (item.label === 'Due Date') {
            const contract = this.contracts.find(c => c._id === contractId);
            this.dueDate = { open: true, selectedDate: contract?.dueDate ? new Date(contract.dueDate) : null, contractId };
        }
    }

    handleClick(event: MouseEvent, menu: PopoverComponent) {
        this.openMenus.forEach(m => m.hide());
        this.openMenus = [];
        menu.toggle(event);
        this.openMenus.push(menu);
    }

    handlePopoverToggle(event: { documentId: string; isOpen: boolean }) {
        if (event.isOpen) {
            if (this.currentlyOpenPopoverId && this.currentlyOpenPopoverId !== event.documentId) {
                this.documentCards?.find(c => c.document._id === this.currentlyOpenPopoverId)?.closePopover();
            }
            this.currentlyOpenPopoverId = event.documentId;
        } else if (this.currentlyOpenPopoverId === event.documentId) {
            this.currentlyOpenPopoverId = null;
        }
    }

    handleMenuItemClick(action: string, menu: PopoverComponent) {
        if (!this.currentMenuDocument) return;
        const { id: contractId, name: contractName } = this.currentMenuDocument;
        if (action === 'Delete') this.deleteContract(new Event('click'), contractId, contractName);
        else if (action === 'Rename') this.rename = { open: true, newName: '', contractId };
        else if (action === 'Due Date') {
            const contract = this.contracts.find(c => c._id === contractId);
            this.dueDate = { open: true, selectedDate: contract?.dueDate ? new Date(contract.dueDate) : null, contractId };
        }
        menu.hide();
    }

    openDocumentMenu(documentId: string, documentName: string) {
        this.currentMenuDocument = { id: documentId, name: documentName };
    }

    getDocumentTypeName(docType: IDocumentType | string): string {
        return (docType as IDocumentType)?.name ?? '';
    }

    getCreatedByName(user: IUser | string): string {
        const userObj = user as IUser;
        return userObj?.fullName ?? userObj?.email ?? '';
    }

    getDocumentStatusName(contract: IContractResponse): string {
        return (contract.documentStatus as IStatus)?.name ?? '';
    }

    ngOnDestroy() {
        this.notificationSubscription?.unsubscribe();
    }


    openGenerateContractDialog() {
        this.generateContractLoading = true
        const source = this.docTypeOptions.find(opt => opt.value === this.selectedDocTypeId)?.data?.name === 'CONTRACT'
            ? DOCUMENT_CREATION_SOURCE.CONTRACT_GENERATION
            : DOCUMENT_CREATION_SOURCE.STANDARD;
        this.contractService.checkGenWithAiInProgress(source).subscribe({
            next: res => {
                if (res && res.data) {
                    this.generateContractLoading = false
                    this.toastService.info('A document generation job is already in progress. Please wait for it to complete.');
                    return;
                }
                this.generateContractLoading = false
                this.generateContractDialogVisible = true;

            },
            error: () => {
                this.generateContractDialogVisible = false;
            }
        });
    }

    onGenerateContract({ docTypeId }: { docTypeId: string }) {
        this.generateContractDialogVisible = false;
        const docType = this.docTypeOptions.find(opt => opt.value === docTypeId);
        const dummyContract: IContractResponse = {
            _id: 'generating-' + Date.now(),
            name: 'Untitled',
            generationStatus: CONTRACT_GENERATION_STATUS.IN_PROGRESS,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
            createdBy: this.currentUser,
            linkedDocType: docType?.data ?? null,
            source: docType?.data?.name === 'CONTRACT' ? DOCUMENT_CREATION_SOURCE.CONTRACT_GENERATION : DOCUMENT_CREATION_SOURCE.STANDARD,
            assignees: [],
            upcomingMilestone: [],
        } as any;
        this.contracts = [dummyContract, ...this.contracts];
    }

    onCloseGenerateContractGeneratingDialog() {
        this.generateContractGeneratingDialogVisible = false;
    }

    onCloseGenerateContractDialog() {
        this.generateContractGeneratingDialogVisible = false;
    }
}
